import useBreakpoints from "./useBreakpoints";

const useIsMobile = () => {
  const { xs, s } = useBreakpoints();
  return xs || s;
};

export default useIsMobile;
